<template>
    <a-date-picker
        :get-calendar-container="getPopupContainer"
        :value="value"
        value-format="YYYY-MM-DD HH:mm:ss"
        :format="dateFormat"
        :show-time="showTime"
        :disabled-date="disabledDate"
        @update:value="onUpdateValue"
        style="width: 100%"
    />
</template>

<script>
import {computed} from "vue";
import moment from "moment";

export default {
    name: "DatePicker",
    emits: ["update:value"],
    props: {
        value: {
            type: [String, undefined, null],
            default: null,
        },
        showTime: {
            type: Boolean,
            default: false,
        },
        start: {
            type: String,
            default: null,
        },
        end: {
            type: String,
            default: null,
        },
    },
    setup(props, {emit}) {
        const dateFormat = computed(() =>
            props.showTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD"
        );
        const disabledDate = (current) => {
            const beforeStartDate = props.start
                ? current.isBefore(moment(props.start).startOf("day"))
                : null;
            const afterEndDate = props.end
                ? current.isAfter(moment(props.end).endOf("day"))
                : null;
            return beforeStartDate || afterEndDate;
        };
        const onUpdateValue = (date) => {
            emit("update:value", date);
        };
        return {
            dateFormat,
            disabledDate,
            onUpdateValue,
        };
    },
};
</script>

<style scoped>
</style>
